/** Normalize clinical record values between FE and BE. */

export type PatchTestStatus = "pending" | "passed" | "failed";
export type AllergySeverity = "mild" | "moderate" | "severe" | "fatal" | "";
export type AllergyType = "non-drug" | "drug" | "no-known";

export function normalizePatchTestStatus(status?: string | null): PatchTestStatus {
  const raw = (status || "").toLowerCase().trim();
  if (raw === "pass" || raw === "passed" || raw === "complete" || raw === "completed") {
    return "passed";
  }
  if (raw === "fail" || raw === "failed") {
    return "failed";
  }
  return "pending";
}

export function normalizeAllergySeverity(
  severity?: string | null,
): AllergySeverity {
  const raw = (severity || "").toLowerCase().trim();
  if (raw === "mild" || raw === "moderate" || raw === "severe" || raw === "fatal") {
    return raw;
  }
  return "";
}

export function normalizeAllergyType(type?: string | null): AllergyType {
  const raw = (type || "").toLowerCase().trim();
  if (raw === "drug" || raw === "drug allergy" || raw === "drug-allergy") {
    return "drug";
  }
  if (
    raw === "no-known" ||
    raw === "no known allergies" ||
    raw === "no known allergy" ||
    raw === "none"
  ) {
    return "no-known";
  }
  return "non-drug";
}

export function addMonthsIso(dateStr: string, months = 6): string {
  try {
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "N/A";
    date.setMonth(date.getMonth() + months);
    return date.toISOString().split("T")[0];
  } catch {
    return "N/A";
  }
}
